const authEmailActions = [
  'signup',
  'invite',
  'magiclink',
  'recovery',
  'email_change',
  'email',
] as const;

export type AuthEmailAction = (typeof authEmailActions)[number];

export type AuthCallbackResult = 'authenticated' | 'no_session';

export function parseAuthEmailAction(value: string | null): AuthEmailAction | null {
  if (value === null) return null;
  return authEmailActions.some((action) => action === value) ? (value as AuthEmailAction) : null;
}

export async function finishAuthCallback(code: string | null): Promise<AuthCallbackResult> {
  try {
    const { exchangeAuthCallbackCode, hasCurrentAuthSession } = await import('./supabase');
    const hasSession = code ? await exchangeAuthCallbackCode(code) : await hasCurrentAuthSession();
    return hasSession ? 'authenticated' : 'no_session';
  } catch (cause) {
    throw new Error('Auth callback could not be completed.', { cause });
  }
}

export async function confirmEmailAction(params: {
  tokenHash: string;
  action: AuthEmailAction;
}): Promise<void> {
  const action = parseAuthEmailAction(params.action);
  if (!action || typeof params.tokenHash !== 'string' || !params.tokenHash.trim()) {
    throw new Error('Auth email action is invalid.');
  }

  try {
    const { verifyAuthEmailAction } = await import('./supabase');
    await verifyAuthEmailAction({ tokenHash: params.tokenHash, action });
  } catch (cause) {
    throw new Error('Auth email action could not be completed.', { cause });
  }
}
